module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content container"
  }, [_vm._m(0), _vm._v(" "), (_vm.campaignId !== null) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.pairingBriefModelSections), function(section) {
    return _c('div', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('h3', [_vm._v(_vm._s(section.title))]), _vm._v(" "), _vm._l((section.content), function(campaignField, index) {
      return _c('element', {
        key: index
      }, [(campaignField.type === 'text') ? _c('div', {
        staticClass: "form-group col-xs-12 col-sm-6",
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campaign[campaignField.name]),
          expression: "campaign[campaignField.name]"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": campaignField.placeholder
        },
        domProps: {
          "value": (_vm.campaign[campaignField.name])
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.campaign, campaignField.name, $event.target.value)
          }, function($event) {
            _vm.$v.campaign[campaignField.name].$touch()
          }]
        }
      }), _vm._v(" "), _vm._l((campaignField.validations), function(validation, index) {
        return _c('span', {
          key: index,
          staticClass: "help-block"
        }, [(_vm.$v.campaign[campaignField.name] && !_vm.$v.campaign[campaignField.name][validation.name] && _vm.$v.campaign[campaignField.name].$error) ? _c('span', [_vm._v("\n                      " + _vm._s(validation.message) + "\n                    ")]) : _vm._e()])
      })], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
        staticClass: "form-group col-xs-12 col-sm-6",
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campaign[campaignField.name]),
          expression: "campaign[campaignField.name]"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "row": "5",
          "placeholder": campaignField.placeholder
        },
        domProps: {
          "value": (_vm.campaign[campaignField.name])
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.campaign, campaignField.name, $event.target.value)
          }, function($event) {
            _vm.$v.campaign[campaignField.name].$touch()
          }]
        }
      }), _vm._v(" "), _vm._l((campaignField.validations), function(validation, index) {
        return _c('span', {
          key: index,
          staticClass: "help-block"
        }, [(_vm.$v.campaign[campaignField.name] && !_vm.$v.campaign[campaignField.name][validation.name] && _vm.$v.campaign[campaignField.name].$error) ? _c('span', [_vm._v("\n                      " + _vm._s(validation.message) + "\n                    ")]) : _vm._e()])
      })], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', {
        staticClass: "form-group col-xs-12 col-sm-6"
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campaign[campaignField.name]),
          expression: "campaign[campaignField.name]"
        }],
        staticClass: "form-control",
        attrs: {
          "name": campaignField.name
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.campaign, campaignField.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((campaignField.value), function(option, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": option.value,
            "selected": {
              selected: option.selected
            }
          }
        }, [_vm._v("\n                      " + _vm._s(option.text) + "\n                    ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('element', [_c('div', {
        staticClass: "form-group col-xs-12"
      }, [_vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex,
          staticClass: "form-group col-xs-12"
        }, [_c('div', {
          staticClass: "form-group col-xs-12"
        }, [_c('h4', [_vm._v(_vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1))]), _vm._v(" "), (_vm.campaign[campaignField.name].length > 1) ? _c('b-button', {
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteOption(campaignField.name, optionIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash ims-text-error"
        })]) : _vm._e()], 1), _vm._v(" "), _vm._l((campaignField.template), function(optionField, index) {
          return _c('element', {
            key: index
          }, [(optionField.type == 'text') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text",
              "placeholder": optionField.placeholder
            },
            domProps: {
              "value": (_vm.campaign[campaignField.name][optionIndex][optionField.name])
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $event.target.value)
              }
            }
          })]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('textarea', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text",
              "placeholder": optionField.placeholder
            },
            domProps: {
              "value": (_vm.campaign[campaignField.name][optionIndex][optionField.name])
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $event.target.value)
              }
            }
          })]) : _vm._e(), _vm._v(" "), (optionField.type == 'upload') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-12"
          }, _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(image, i) {
            return _c('div', {
              key: image
            }, [(image != '') ? _c('div', [_c('a', {
              staticClass: "campaign-image",
              attrs: {
                "href": _vm.constructImageURL(image),
                "target": "_blank"
              }
            }, [_c('img', {
              staticStyle: {
                "width": "100%"
              },
              attrs: {
                "src": _vm.constructImageURL(image)
              }
            })]), _vm._v(" "), _c('button', {
              staticClass: "btn btn-link btn-link-danger",
              attrs: {
                "type": "button"
              },
              on: {
                "click": function($event) {
                  $event.preventDefault();
                  return _vm.removeImage(optionIndex, i)
                }
              }
            }, [_vm._v("Remove")])]) : _vm._e()])
          }), 0), _vm._v(" "), _c('div', {
            staticClass: "col-xs-12"
          }, [_c('div', {
            staticClass: "image-input-container-edit",
            attrs: {
              "data-index": optionIndex
            }
          }, [_c('div', {
            staticClass: "image-input-edit"
          }, [_c('input', {
            ref: "files",
            refInFor: true,
            attrs: {
              "type": "file"
            }
          }), _vm._v(" "), _c('button', {
            staticClass: "btn btn-link btn-link-danger btn-remove-input-edit",
            attrs: {
              "type": "button"
            }
          }, [_vm._v("Remove")])])]), _vm._v(" "), _c('button', {
            staticClass: "btn btn-default btn-sm btn-add-more-image-edit",
            attrs: {
              "type": "button"
            }
          }, [_vm._v("+ Add more image")])])]) : _vm._e(), _vm._v(" "), (optionField.type === 'select') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }],
            staticClass: "form-control",
            attrs: {
              "name": optionField.name
            },
            on: {
              "change": function($event) {
                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                  return o.selected
                }).map(function(o) {
                  var val = "_value" in o ? o._value : o.value;
                  return val
                });
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }
            }
          }, _vm._l((optionField.value), function(option, index) {
            return _c('option', {
              key: index,
              domProps: {
                "value": option.value,
                "selected": {
                  selected: option.selected
                }
              }
            }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                          ")])
          }), 0)]) : _vm._e()])
        })], 2)
      }), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-12"
      }, [_c('button', {
        staticClass: "btn btn-primary",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addOption(campaignField.name)
          }
        }
      }, [_vm._v("\n                        Add new option\n                      ")])])], 2)]) : _vm._e()])
    })], 2)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default secondary--text",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Close\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary primary--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCampaign
    }
  }, [_vm._v("\n          Save changes\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Edit Pairing Brief\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a4b51f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/EditPairingBriefModal.vue
// module id = 2142
// module chunks = 0